'use strict';

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates;
    if (selector === '.top-filter-slide-sample') {
        $updates = $results.find(
            '.top-filter .container .top-filter-slide-sample .list-catagory'
        );
        $updates.each(function () {
            var id = $(this).data('id');
            var url = $(this).find('a').data('href');
            $(
                '.top-filter .container .top-filter-slide-sample:visible .list-catagory[data-id="' +
					id +
					'"] a'
            ).attr('data-href', url);
            if ($(this).hasClass('selected')) {
                $(
                    '.top-filter .container .top-filter-slide-sample:visible .list-catagory[data-id="' +
						id +
						'"]'
                ).addClass('selected');
            } else {
                $(
                    '.top-filter .container .top-filter-slide-sample:visible .list-catagory[data-id="' +
						id +
						'"]'
                ).removeClass('selected');
            }
        });
        $results.find('.top-filter').remove();
    } else {
        $updates = $results.find(selector);
        $(selector).empty().html($updates.html());
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.show').each(function () {
        $(this).removeClass('show');
        var activeDiv = $results.find(
            '.refinement-wrapper .' + $(this)[0].className.replace(/ /g, '.')
        );
        activeDiv.addClass('show');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements,
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.top-filter-slide-sample',
        '.horizontal-filter',
        '.selected-refinement-filters',
        '.count-result',
        '.search-result-count-text',
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        },
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').show();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar')
                .closest('.tab-pane.active')
                .siblings()
                .attr('aria-hidden', true);
            $('.refinement-bar')
                .closest('.container.search-results')
                .siblings()
                .attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('.container').on(
            'click',
            '.refinement-bar button.close, .modal-background',
            function () {
                $('.refinement-bar, .modal-background').hide();
                $('.refinement-bar').siblings().attr('aria-hidden', false);
                $('.refinement-bar')
                    .closest('.row')
                    .siblings()
                    .attr('aria-hidden', false);
                $('.refinement-bar')
                    .closest('.tab-pane.active')
                    .siblings()
                    .attr('aria-hidden', false);
                $('.refinement-bar')
                    .closest('.container.search-results')
                    .siblings()
                    .attr('aria-hidden', false);
                $('.btn.filter-results').focus();
            }
        );
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar')
                .closest('.row')
                .siblings()
                .attr('aria-hidden', false);
            $('.refinement-bar')
                .closest('.tab-pane.active')
                .siblings()
                .attr('aria-hidden', false);
            $('.refinement-bar')
                .closest('.container.search-results')
                .siblings()
                .attr('aria-hidden', false);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('body').on('change', '.container [name=sort-order]', function (e) {
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $(document).on(
            'click',
            '.refinements li button, .horizontal-filter li button, .price-slider .apply-price-filter, .refinement-bar button.reset, .filter-value button, .swatch-filter button, .selected-refinements .delete',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                var selectedRefinementURL = $(this).data('href');
                var url = new URL(selectedRefinementURL);
                if ($(this).hasClass('apply-price-filter')) {
                    let pmin = parseInt(
                        $(this).closest('.price-slider').find('#minRange').val(),
                        10
                    );
                    var pmax = parseInt(
                        $(this).closest('.price-slider').find('#maxRange').val(),
                        10
                    );
                    url.searchParams.delete('pmin');
                    url.searchParams.delete('pmax');
                    if (pmin > 0) {
                        url.searchParams.set('pmin', pmin);
                    }
                    if (pmax < 5000) {
                        url.searchParams.set('pmax', pmax);
                    }
                }
                var sortOrder = $('.container')
                    .find('[name=sort-order] option:selected')
                    .data('id');
                url.searchParams.set('srule', sortOrder); // setting your param
                $(this).trigger('search:filter', e);
                var attributeId = '#' + $(this).find('span').last().attr('id');

                $.ajax({
                    url: url.href,
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: url.href,
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        $.spinner().stop();
                        $(attributeId).parent('button').focus();
                    },
                    error: function () {
                        $.spinner().stop();
                        $(attributeId).parent('button').focus();
                    },
                });
            }
        );
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },

    topCategorySlider: function () {
        $('.top-filter-slide').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 6,
            variableWidth: false,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    },

    applyLevel2Filter: function () {
        // Handle refinement value selection and reset click
        $('.container').on('click', '.top-filter-slide a', function (e) {
            e.preventDefault();
            e.stopPropagation();

            $.spinner().start();
            $(this).trigger('search:filter', e);
            $.ajax({
                url: $(this).attr('data-href'),
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: $(this).attr('data-href'),
                },
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    // $('.top-filter-slide').slick('unslick');
                    // module.exports.topCategorySlider();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    },
    initHistory: function () {
        let previousHistoryState;
        let doNotPushHistory = false;

        /**
		 * Listen to all possible AJAX calls on a search page (Filters, sorting, show more, ...).
		 */
        $(document).ajaxSuccess(function (event, xhr) {
            // Make the assumption that a product-tile being present in the response means a grid-refresh
            if (xhr.responseText.indexOf('<div class="product-tile">') >= 0) {
                if (!doNotPushHistory) {
                    setTimeout(function () {
                        // eslint-disable-next-line no-restricted-globals
                        history.pushState(
                            { reapplyFilters: true },
                            document.title,
                            decodeURI($('.permalink').val())
                        );
                    });
                }

                doNotPushHistory = false;
            }
        });

        /**
		 * Listen to the back and forward button of the browser to detect URL changes.
		 */
        window.addEventListener('popstate', () => {
            if (
                (history.state && history.state.reapplyFilters) || // eslint-disable-line no-restricted-globals
				(previousHistoryState && previousHistoryState.reapplyFilters)
            ) {
                const $resetButton = $('.refinement-bar button.reset');
                // eslint-disable-next-line no-restricted-globals
                previousHistoryState = history.state;

                // This async call should not cause a new history state to be pushed.
                doNotPushHistory = true;

                // Use the reset button listeners to do a refresh
                $resetButton.data('href', decodeURI(window.location.href));
                $resetButton.trigger('click');
            }
        });
    },
    updateADAAttributes: function () {
        $('body').on('click', '.refinements .collapsible.refinement', function () {
            var label = $(this).find('h2').attr('aria-label');
            if ($(this).hasClass('show')) {
                $(this)
                    .find('svg')
                    .attr('aria-label', 'expand ' + label);
                $(this).find('svg').attr('aria-expanded', 'false');
            } else {
                $(this)
                    .find('svg')
                    .attr('aria-label', 'collapse ' + label);
                $(this).find('svg').attr('aria-expanded', 'true');
            }
        });
        $('body').on(
            'keydown',
            '.refinements .collapsible.refinement',
            function (event) {
                if (event.keyCode === 13) {
                    if ($(this).hasClass('show')) {
                        $(this).removeClass('show');
                    } else {
                        $(this).addClass('show');
                    }
                }
            }
        );
    },

    horizontalFillterNav: function () {
        $('body').on(
            'mouseenter focusin touchstart',
            '.horizontal-filter .refinement',
            function () {
                let parentDiv = $(this);
                $(parentDiv).addClass('is-active');
            }
        );

        $('body').on(
            'mouseleave focusout',
            '.horizontal-filter .refinement',
            function () {
                let parentDiv = $(this);
                // Delay to let focus move within the refinement block
                setTimeout(() => {
                    const isHovered = parentDiv.is(':hover');

                    if (!isHovered) {
                        parentDiv.removeClass('is-active');
                    }
                }, 100);
            }
        );
    },
    priceRangeHandler: function () {
        $('body').on(
            'input',
            '.horizontal-filter .refinement .price-slider .slider, .refinement-bar .refinement .price-slider .slider',
            function (event) {
                var minInput = $(this)
                    .closest('.price-slider')
                    .find('#minPriceInput')[0];
                var maxInput = $(this)
                    .closest('.price-slider')
                    .find('#maxPriceInput')[0];
                var minRange = $(this).closest('.price-slider').find('#minRange')[0];
                var maxRange = $(this).closest('.price-slider').find('#maxRange')[0];
                var progress = $(this).closest('.price-slider').find('.progress')[0];
                var plusSign = $(this).closest('.price-slider').find('.plus-suffix');

                var minVal = parseInt(minRange.value, 10);
                var maxVal = parseInt(maxRange.value, 10);
                if (maxVal - minVal < 100) {
                    if (event.target === minRange) {
                        minRange.value = maxVal - 100;
                    } else {
                        maxRange.value = minVal + 100;
                    }
                }

                minInput.value = minRange.value;
                maxInput.value = maxRange.value;
                if (maxRange.value >= 5000) {
                    plusSign.removeClass('d-none');
                } else {
                    plusSign.addClass('d-none');
                }
                var percent1 = (minRange.value / minRange.max) * 100;
                var percent2 = (maxRange.value / maxRange.max) * 100;

                progress.style.left = percent1 + '%';
                progress.style.width = percent2 - percent1 + '%';
            }
        );
        $('body').on(
            'input',
            '.refinement .price-slider #minPriceInput,.refinement .price-slider #maxPriceInput',
            function (event) {
                var minInput = $(this)
                    .closest('.price-slider')
                    .find('#minPriceInput')[0];
                var maxInput = $(this)
                    .closest('.price-slider')
                    .find('#maxPriceInput')[0];
                var minRange = $(this).closest('.price-slider').find('#minRange')[0];
                var maxRange = $(this).closest('.price-slider').find('#maxRange')[0];
                var progress = $(this).closest('.price-slider').find('.progress')[0];
                var plusSign = $(this).closest('.price-slider').find('.plus-suffix');

                var minVal = parseInt(minRange.value, 10);
                var maxVal = parseInt(maxRange.value, 10);
                if (maxVal - minVal < 100) {
                    if (event.target === minRange) {
                        minRange.value = maxVal - 100;
                    } else {
                        maxRange.value = minVal + 100;
                    }
                }

                minRange.value = minInput.value;
                maxRange.value = maxInput.value;

                if (maxRange.value >= 5000) {
                    plusSign.removeClass('d-none');
                } else {
                    plusSign.addClass('d-none');
                }
                var percent1 = (minRange.value / minRange.max) * 100;
                var percent2 = (maxRange.value / maxRange.max) * 100;

                progress.style.left = percent1 + '%';
                progress.style.width = percent2 - percent1 + '%';
            }
        );
    },
};
